var building_amenities = {
  building_amenities: {
    air_conditioning: {
      id: "35",
      txt_id: "air_conditioning",
      name: "Air Conditioning",
      description: "Air Conditioning",
      default_icon_location: null
    },
    assisted_living: {
      id: "36",
      txt_id: "assisted_living",
      name: "Assisted Living",
      description: "Assisted Living",
      default_icon_location: null
    },
    balcony: {
      id: "37",
      txt_id: "balcony",
      name: "Balcony",
      description: "Balcony",
      default_icon_location: null
    },
    basketball_court: {
      id: "38",
      txt_id: "basketball_court",
      name: "Basketball Court",
      description: "Basketball Court",
      default_icon_location: null
    },
    bike_storage: {
      id: "39",
      txt_id: "bike_storage",
      name: "Bike Storage",
      description: "Bike Storage",
      default_icon_location: null
    },
    billiards_room: {
      id: "40",
      txt_id: "billiards_room",
      name: "Billiards Room",
      description: "Billiards Room",
      default_icon_location: null
    },
    bowling_ally: {
      id: "26",
      txt_id: "bowling_ally",
      name: "Bowling Ally",
      description: "Bowling Ally",
      default_icon_location: null
    },
    builtin_vacuum: {
      id: "41",
      txt_id: "builtin_vacuum",
      name: "Builtin Vacuum",
      description: "Builtin Vacuum",
      default_icon_location: null
    },
    car_charging: {
      id: "23",
      txt_id: "car_charging",
      name: "EV Charging",
      description: "EV Charging",
      default_icon_location: null
    },
    car_valet: {
      id: "3",
      txt_id: "car_valet",
      name: "Car Valet",
      description: "Car Valet",
      default_icon_location: null
    },
    caretaker: {
      id: "42",
      txt_id: "caretaker",
      name: "Caretaker",
      description: "Caretaker",
      default_icon_location: null
    },
    change_room: {
      id: "43",
      txt_id: "change_room",
      name: "Change Room",
      description: "Change Room",
      default_icon_location: null
    },
    clubhouse: {
      id: "44",
      txt_id: "clubhouse",
      name: "Clubhouse",
      description: "Clubhouse",
      default_icon_location: null
    },
    concierge: {
      id: "45",
      txt_id: "concierge",
      name: "Concierge",
      description: "Concierge",
      default_icon_location: null
    },
    courtyard: {
      id: "46",
      txt_id: "courtyard",
      name: "Courtyard",
      description: "Courtyard",
      default_icon_location: null
    },
    daycare: {
      id: "19",
      txt_id: "daycare",
      name: "Daycare",
      description: "Daycare",
      default_icon_location: null
    },
    dog_minding: {
      id: "20",
      txt_id: "dog_minding",
      name: "Dog Minding",
      description: "Dog Minding",
      default_icon_location: null
    },
    doorman: {
      id: "1",
      txt_id: "doorman",
      name: "Doorman",
      description: "Doorman",
      default_icon_location: null
    },
    elevator: {
      id: "47",
      txt_id: "elevator",
      name: "Elevator",
      description: "Elevator",
      default_icon_location: null
    },
    exercise_centre: {
      id: "48",
      txt_id: "exercise_centre",
      name: "Exercise Centre",
      description: "Exercise Centre",
      default_icon_location: null
    },
    family_room: {
      id: "49",
      txt_id: "family_room",
      name: "Family Room",
      description: "Family Room",
      default_icon_location: null
    },
    fireplace: {
      id: "50",
      txt_id: "fireplace",
      name: "Fireplace",
      description: "Fireplace",
      default_icon_location: null
    },
    games_room: {
      id: "33",
      txt_id: "games_room",
      name: "Games Room",
      description: "Games Room",
      default_icon_location: null
    },
    garbage_pickup: {
      id: "52",
      txt_id: "garbage_pickup",
      name: "Garbage Pickup",
      description: "Garbage Pickup",
      default_icon_location: null
    },
    garbage_valet: {
      id: "4",
      txt_id: "garbage_valet",
      name: "Garbage Valet",
      description: "Garbage Valet",
      default_icon_location: null
    },
    garden: {
      id: "53",
      txt_id: "garden",
      name: "Garden",
      description: "Garden",
      default_icon_location: null
    },
    gated_complex: {
      id: "54",
      txt_id: "gated_complex",
      name: "Gated Complex",
      description: "Gated Complex",
      default_icon_location: null
    },
    gourmet_kitchens: {
      id: "55",
      txt_id: "gourmet_kitchens",
      name: "Gourmet Kitchens",
      description: "Gourmet Kitchens",
      default_icon_location: null
    },
    guest_suite: {
      id: "56",
      txt_id: "guest_suite",
      name: "Guest Suite",
      description: "Guest Suite",
      default_icon_location: null
    },
    gym: {
      id: "6",
      txt_id: "gym",
      name: "Gym",
      description: "Gym",
      default_icon_location: null
    },
    high_ceilings: {
      id: "57",
      txt_id: "high_ceilings",
      name: "High Ceilings",
      description: "High Ceilings",
      default_icon_location: null
    },
    hot_tub: {
      id: "58",
      txt_id: "hot_tub",
      name: "Hot Tub",
      description: "Hot Tub",
      default_icon_location: null
    },
    indoor_basketball_court: {
      id: "31",
      txt_id: "indoor_basketball_court",
      name: "Indoor Basketball Court",
      description: "Indoor Basketball Court",
      default_icon_location: null
    },
    indoor_pool: {
      id: "59",
      txt_id: "indoor_pool",
      name: "Indoor Pool",
      description: "Indoor Pool",
      default_icon_location: null
    },
    insuite_laundry: {
      id: "60",
      txt_id: "insuite_laundry",
      name: "Insuite Laundry",
      description: "Insuite Laundry",
      default_icon_location: null
    },
    insuite_storage: {
      id: "61",
      txt_id: "insuite_storage",
      name: "Insuite Storage",
      description: "Insuite Storage",
      default_icon_location: null
    },
    laundry: {
      id: "62",
      txt_id: "laundry",
      name: "Laundry",
      description: "Laundry",
      default_icon_location: null
    },
    library: {
      id: "63",
      txt_id: "library",
      name: "Library",
      description: "Library",
      default_icon_location: null
    },
    lounge: {
      id: "64",
      txt_id: "lounge",
      name: "Lounge",
      description: "Lounge",
      default_icon_location: null
    },
    massage_spa_room: {
      id: "97",
      txt_id: "massage_spa_room",
      name: "Massage / Spa Room",
      description: "Massage / Spa Room",
      default_icon_location: null
    },
    media_room: {
      id: "65",
      txt_id: "media_room",
      name: "Media Room",
      description: "Media Room",
      default_icon_location: null
    },
    meeting_room: {
      id: "66",
      txt_id: "meeting_room",
      name: "Meeting Room",
      description: "Meeting Room",
      default_icon_location: null
    },
    outdoor_basketball_court: {
      id: "30",
      txt_id: "outdoor_basketball_court",
      name: "Outdoor Basketball Court",
      description: "Outdoor Basketball Court",
      default_icon_location: null
    },
    outdoor_pool: {
      id: "67",
      txt_id: "outdoor_pool",
      name: "Outdoor Pool",
      description: "Outdoor Pool",
      default_icon_location: null
    },
    parking: {
      id: "68",
      txt_id: "parking",
      name: "Parking",
      description: "Parking",
      default_icon_location: null
    },
    patio_deck_terrace: {
      id: "99",
      txt_id: "patio_deck_terrace",
      name: "Patio / Deck / Terrace",
      description: "Patio / Deck / Terrace",
      default_icon_location: null
    },
    playground: {
      id: "70",
      txt_id: "playground",
      name: "Playground",
      description: "Playground",
      default_icon_location: null
    },
    pool: {
      id: "71",
      txt_id: "pool",
      name: "Pool",
      description: "Pool",
      default_icon_location: null
    },
    private_yard: {
      id: "72",
      txt_id: "private_yard",
      name: "Private Yard",
      description: "Private Yard",
      default_icon_location: null
    },
    recreation_centre: {
      id: "73",
      txt_id: "recreation_centre",
      name: "Recreation Centre",
      description: "Recreation Centre",
      default_icon_location: null
    },
    recreation_room: {
      id: "74",
      txt_id: "recreation_room",
      name: "Recreation Room",
      description: "Recreation Room",
      default_icon_location: null
    },
    restaurant: {
      id: "75",
      txt_id: "restaurant",
      name: "Restaurant",
      description: "Restaurant",
      default_icon_location: null
    },
    rv_parking: {
      id: "77",
      txt_id: "rv_parking",
      name: "Rv Parking",
      description: "Rv Parking",
      default_icon_location: null
    },
    sauna: {
      id: "78",
      txt_id: "sauna",
      name: "Sauna",
      description: "Sauna",
      default_icon_location: null
    },
    sauna_steam_room: {
      id: "103",
      txt_id: "sauna_steam_room",
      name: "Sauna / Steam Room",
      description: "Sauna / Steam Room",
      default_icon_location: null
    },
    secured_underground_parking: {
      id: "80",
      txt_id: "secured_underground_parking",
      name: "Secured Underground Parking",
      description: "Secured Underground Parking",
      default_icon_location: null
    },
    security: {
      id: "5",
      txt_id: "security",
      name: "Security",
      description: "Security",
      default_icon_location: null
    },
    security_system: {
      id: "81",
      txt_id: "security_system",
      name: "Security System",
      description: "Security System",
      default_icon_location: null
    },
    shared_laundry: {
      id: "82",
      txt_id: "shared_laundry",
      name: "Shared Laundry",
      description: "Shared Laundry",
      default_icon_location: null
    },
    smoking_area: {
      id: "104",
      txt_id: "smoking_area",
      name: "Smoking Area",
      description: "Smoking Area",
      default_icon_location: null
    },
    squash_court: {
      id: "84",
      txt_id: "squash_court",
      name: "Squash Court",
      description: "Squash Court",
      default_icon_location: null
    },
    steam_room: {
      id: "85",
      txt_id: "steam_room",
      name: "Steam Room",
      description: "Steam Room",
      default_icon_location: null
    },
    storage_area: {
      id: "86",
      txt_id: "storage_area",
      name: "Storage Area",
      description: "Storage Area",
      default_icon_location: null
    },
    table_tennis_room: {
      id: "29",
      txt_id: "table_tennis_room",
      name: "Table Tennis Room",
      description: "Table Tennis Room",
      default_icon_location: null
    },
    tennis_court: {
      id: "87",
      txt_id: "tennis_court",
      name: "Tennis Court",
      description: "Tennis Court",
      default_icon_location: null
    },
    vaulted_ceilings: {
      id: "89",
      txt_id: "vaulted_ceilings",
      name: "Vaulted Ceilings",
      description: "Vaulted Ceilings",
      default_icon_location: null
    },
    visitors_parking: {
      id: "90",
      txt_id: "visitors_parking",
      name: "Visitors Parking",
      description: "Visitors Parking",
      default_icon_location: null
    },
    wall_climbing: {
      id: "7",
      txt_id: "wall_climbing",
      name: "Wall Climbing",
      description: "Wall Climbing",
      default_icon_location: null
    },
    waste_disposal_chute: {
      id: "18",
      txt_id: "waste_disposal_chute",
      name: "Waste Disposal Chute",
      description: "Waste Disposal Chute",
      default_icon_location: null
    },
    wheelchair_accessible: {
      id: "91",
      txt_id: "wheelchair_accessible",
      name: "Wheelchair Accessible",
      description: "Wheelchair Accessible",
      default_icon_location: null
    },
    workshop: {
      id: "92",
      txt_id: "workshop",
      name: "Workshop",
      description: "Workshop",
      default_icon_location: null
    },
    yoga_room: {
      id: "25",
      txt_id: "yoga_room",
      name: "Yoga Room",
      description: "Yoga Room",
      default_icon_location: null
    }
  }
}

module.exports = building_amenities
